import { externalApiClient } from '@/shared/lib/apiClient';
import axios from 'axios';
import { createCachedFetch } from '@/shared/lib/cache';
import type { OperatorView } from './operator.types';

/** Account API 응답 스펙 (GET /api/v1/accounts/{accountId}) */
interface AccountViewResponse {
  id: string;
  name: string;
  email: string;
  phone: string;
  type: string;
  plannerId: string | null;
}

/**
 * 계정(Account) ID로 단건 조회 - Operator/매니저 표시용
 * @see GET /api/v1/accounts/{accountId}
 * @internal 클라이언트 레이어에서 캐시 래핑하여 사용
 */
async function fetchAccountById(accountId: string): Promise<OperatorView> {
  try {
    const headers = { 'Content-Type': 'application/json' };
    const response = await externalApiClient.get<AccountViewResponse>(
      `/api/v1/accounts/${accountId}`,
      { headers }
    );
    const data = response.data;
    return {
      id: data.id,
      name: data.name,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        '계정 조회에 실패했습니다.';
      throw new Error(errorMessage);
    }
    throw new Error('알 수 없는 오류가 발생했습니다.');
  }
}

const getOperatorById = createCachedFetch(fetchAccountById, 'account');

export const operatorApi = {
  getOperatorById,
};

export { getOperatorById };
export type { OperatorView };
